/*
הגדרות משתנים של mdb
*/

const FILE_UPLOAD_OPTIONS = {
  defaultMsg: "לחצו לבחירת תמונה",
  formatError: "לקובץ שלך יש פורמט קובץ שגוי (פורמט(ים) נכונים ~~~)",
  mainError: "אופס, שגיאה כללית",
  maxSizeError: "הקובץ שלך גדול מדי (גודל מקסימלי ~~~)",
  previewMsg: "גרור ושחרר או לחץ כדי להחליף",
  removeBtn: "מחחיקה",
};
const DATATABALE_OPTIONS = {
  actionHeader: "פעולה",
  newItemHeader: "פריט חדש",
  cancelText: "ביטל",
  confirmText: "אשר",
  confirmMessage: "האם אתה בטוח שברצונך למחוק רשומה זו?",
  allText: "הכל",
  loadingMessage: "טוען נתונים.....",
  noFoundMessage: "לא נמצאו תוצאות מתאימות",
  rowsText: "מספר שורות בעמוד",
  ofText: "מתוך",
  loading: false,
};
const DATEPICKER_OPTIONS = {
  format: "dd/mm/yyyy",
  disablePast: false,
  toggleButton: false,
  title: "תאריך",
  cancelBtnLabel: "ביטול",
  cancelBtnText: "ביטול",
  clearBtnLabel: "נקה",
  clearBtnText: "נקה",
  okBtnLabel: "בחירה",
  okBtnText: "בחירה",
  switchToDayViewLabel: "בחר תאריך",
  switchToMonthViewLabel: "בחר תאריך",
  switchToMultiYearViewLabel: "בחר שנה וחודש",
  weekdaysFull: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
  weekdaysNarrow: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
  weekdaysShort: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
  monthsFull: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
  monthsShort: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
};
const TIMEPICKER_OPTIONS = {
  format24: true,
  cancelLabel: "ביטול",
  clearLabel: "נקה",
  invalidLabel: "פורמט זמן לא חוקי",
  okLabel: "אישור",
  inline: false,
};
const SELECT_OPTIONS = {
  invalidFeedback: "שדה חובה",
  validFeedback: "תקין",
  noResultText: "לא נמצאו תוצאות",
  optionsSelectedLabel: "בחירת פריט מרשימה",
  selectAllLabel: "בחירת הכל",
  searchPlaceholder: "חיפוש.....",
};

const AUTOCOMPLETE_OPTIONS = {
  noResults: "אין תוצאות חיפוש",
};

const LIGHTPICK_OPTIONS = {
  lang: "he",
  singleDate: false,
  inline: true,
  footer:false,

  minDate: new Date(),
  numberOfColumns: 2,
  numberOfMonths: 2,
  locale: {
    
    buttons: {
      next: "←",
      prev: "→",
    },
    format: "DD/MM/YYYY",
    tooltip: {
      one: "מתאריך",
      few: "עד תאריך",
      many: "תאריכים",
    },
  },
};

const WYSIWYG_OPTIONS = {};
let ILS_CURRENCY = new Intl.NumberFormat("he-IL", {
  style: "currency",
  currency: "ILS",
});
document.addEventListener("DOMContentLoaded", () => {
  const CurrencyInputElms = document.querySelectorAll(".currency-input");
  CurrencyInputElms.forEach((input) => {
    input.addEventListener("change", async (evt) => {
      evt.target.value = ILS_CURRENCY.format(evt.target.value);
    });
  });
});
